import React from 'react';

import useGetRequest from 'src/hooks/useGetRequest';
import Stepper from '../../../../shared/Stepper';

const EngagementProcess = ({
  workflowId,
  engagementId
}: any) => {
  const { result: workflow, isLoading: workflowLoading } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/`,
    initialResult: { steps: [], edges: [] },
  });
  const {
    result: engagement,
    isLoading: engagementLoading,
  } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/`,
    initialResult: { stepId: null }
  });
  const {
    result: stepEvents,
    isLoading: stepEventsLoading,
  } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/events/`,
    initialResult: []
  });

  return (
    <Stepper
      events={stepEvents}
      workflow={workflow}
      currentStepId={engagement.stepId}
      isLoading={workflowLoading || stepEventsLoading || engagementLoading}
    />
  );
};

export default EngagementProcess;
